import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Currency, DataTypeOptions, Loan } from '@core/constants/data-types.constants';
import { getFieldError, isFieldInvalid, isFieldValid } from '@shared/utils/forms/validations.util';

@Component({
  selector: 'mfp-loan',
  templateUrl: './loan.component.html',
  styleUrls: ['./loan.component.scss']
})
export class LoanComponent {
  @Input() form: FormGroup = new FormGroup({});
  @Input() label = '';
  @Input() readonly = false;
  @Input() required = false;

  @Input() currencyOptions: DataTypeOptions<Currency> = [];
  @Input() pendingAmountName = '';
  @Input() pendingAmountLabel = '';

  @Input() monthlyFeeName = '';
  @Input() monthlyFeeLabel = '';

  @Input() loanTypeName = '';
  @Input() loanTypeLabel = '';
  @Input() loanTypePlaceholder = '';
  @Input() loanTypeOptions: DataTypeOptions<Loan> = [];
  @Input() loanTypeColor: 'primary' | 'light' = 'primary';

  @Input() remainingYearsName = '';
  @Input() remainingYearsLabel = '';
  @Input() remainingYearsPlaceholder = '';

  @Input() removeLabel = '';
  @Input() removeFill: 'default' | 'clear' | 'outline' = 'clear';
  @Input() removeSize: 'medium' | 'small' | 'tiny' = 'tiny';
  @Input() removeIcon = 'assets/icons/delete.svg';
  @Input() removeIconPosition: 'left' | 'right' = 'left';
  @Output() removeItem = new EventEmitter();

  isFieldValid = isFieldValid;
  isFieldInvalid = isFieldInvalid;
  getFieldError = getFieldError;

  remove(): void {
    this.removeItem.emit();
  }
}
